import { createReducer } from '@reduxjs/toolkit';

import initialState from './menu.initialState';
import { ACTION_TYPES } from './menu.constant';

const handleOpen = (state, action) => {
  state.visible = true;
  state.payload = action.payload;
};

const handleClose = (state) => {
  state.visible = false;
  state.payload = null;
};

const handleUpdateCollapses = (state, action) => {
  state.collapses = action.payload;
};

const handleReset = () => initialState;

export default createReducer(initialState, {
  [ACTION_TYPES.SET.OPEN]: handleOpen,
  [ACTION_TYPES.SET.CLOSE]: handleClose,
  [ACTION_TYPES.UPDATE.COLLAPSES]: handleUpdateCollapses,
  [ACTION_TYPES.RESET]: handleReset,
});
